/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { password, routes, useRouter } from '@builddocs/data-management'
import { useLogin } from '@builddocs/data-management-auth'
import { Alert, Button, Link, Stack, TextField } from '@mui/material'
import { SubmitHandler, useForm, Controller } from 'react-hook-form'
import { Link as RouterLink } from 'react-router-dom'

interface IFormFields {
  email: string
  password: string
}

const SignInForm = () => {
  const { control, handleSubmit, errors, register } = useForm<IFormFields>()

  const { login, isLoading, errorMessage } = useLogin({
    redirectUrl: routes.navigator.base(),
  })
  const { query } = useRouter()
  const onSubmit: SubmitHandler<IFormFields> = body => {
    localStorage.setItem('REALM', 'BUILDDOCS')
    login({
      username: body.email,
      password: body.password,
    }).then(() => {
      if (query?.redirectTo) {
        window.location.href = query.redirectTo
      }
      return
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack alignItems="stretch">
        <Controller
          as={
            <TextField
              error={!!errors?.email?.message}
              helperText={errors?.email?.message}
              label="Телефон или e-mail"
              name="email"
              size="small"
              sx={{ mb: { xs: 2, lg: 2 } }}
              variant="outlined"
            />
          }
          control={control}
          name="email"
          rules={{
            required: 'Должно быть заполнено',
          }}
        />
        <TextField
          error={!!errors?.password?.message}
          helperText={errors?.password?.message}
          inputRef={register({
            required: 'Пароль нужен',
            validate: password,
          })}
          label="Пароль"
          name="password"
          size="small"
          sx={{ mb: { xs: 1, lg: 1 } }}
          type="password"
          variant="outlined"
        />

        <Link
          component={RouterLink}
          sx={{ mb: { xs: 1, lg: 1.5 } }}
          textAlign="right"
          to={routes.auth.forgotPassword()}
          underline="hover"
        >
          Забыли пароль?
        </Link>
        <Button
          fullWidth
          disabled={isLoading}
          size="large"
          sx={{
            mt: 1,
            py: 1.5,
            textTransform: 'none',
            fontSize: 14,
          }}
          type="submit"
          variant="contained"
        >
          Войти
        </Button>
        {!!errorMessage && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMessage}
          </Alert>
        )}
      </Stack>
    </form>
  )
}

export default SignInForm
